import {
  Action,
  actionCreator,
  FailableAction,
  failableActionCreator,
  Memoed,
  PayloadAction,
  payloadActionCreator,
} from '@library/react-toolkit'
import { LocationChangeAction } from 'connected-react-router'
import { option } from 'fp-ts'
import * as t from 'io-ts'
import { withFallback } from 'io-ts-types'

export const PeriodInfo = t.type({
  period: t.string,
  paidAmount: t.number,
  unpaidAmount: t.number,
  lateAmount: t.number,
  unitID: t.string,
})

export const PeriodInfoData = t.type({
  count: t.number,
  data: t.array(PeriodInfo),
})

export type PeriodInfo = t.TypeOf<typeof PeriodInfo>

export type Query = { page: number; itemsPerPage: number }

export type PeriodInfoData = { data: PeriodInfo[]; count: number }

export const PeriodSummary = t.type({
  amount: t.record(
    t.string,
    t.type({
      dueAmount: withFallback(t.number, 0),
      paidAmount: withFallback(t.number, 0),
    })
  ),
  period: t.string,
})

export type PeriodSummary = t.TypeOf<typeof PeriodSummary>

export type State = {
  periodInfo: Memoed<PeriodInfoData>
  currentPeriodSummary: Memoed<PeriodSummary>
  lastTransferDate: Memoed<option.Option<Date>>
  query: Query
}

export type GetPeriodInfoAction = PayloadAction<
  'HOME/get_period_info',
  Partial<Query>
>
export const getPeriodInfoAction = payloadActionCreator<GetPeriodInfoAction>(
  'HOME/get_period_info'
)

export type GetPeriodInfoActionResult = FailableAction<
  'HOME/get_period_info_result',
  PeriodInfoData
>
export const getPeriodInfoActionResult =
  failableActionCreator<GetPeriodInfoActionResult>(
    'HOME/get_period_info_result'
  )

export type GetLastTransferDateAction = Action<'HOME/get_last_transfer_date'>
export const getLastTransferDateAction =
  actionCreator<GetLastTransferDateAction>('HOME/get_last_transfer_date')

export type GetLastTransferDateResult = FailableAction<
  'HOME/get_last_transfer_date_result',
  option.Option<Date>
>
export const getLastTransferDateResult =
  failableActionCreator<GetLastTransferDateResult>(
    'HOME/get_last_transfer_date_result'
  )

export type GetCurrentPeriodAction = Action<'HOME/get_current_period'>
export const getCurrentPeriodAction = actionCreator<GetCurrentPeriodAction>(
  'HOME/get_current_period'
)

export type GetCurrentPeriodResult = FailableAction<
  'HOME/get_current_period_result',
  PeriodSummary
>
export const getCurrentPeriodResult =
  failableActionCreator<GetCurrentPeriodResult>(
    'HOME/get_current_period_result'
  )

export type Actions =
  | GetPeriodInfoAction
  | GetPeriodInfoActionResult
  | GetLastTransferDateAction
  | GetLastTransferDateResult
  | LocationChangeAction
  | GetCurrentPeriodAction
  | GetCurrentPeriodResult
